import { useCallback, useEffect, useRef, useState } from 'react'
import { View, Text, Image, StyleSheet, TouchableOpacity } from 'react-native'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { Ionicons, Octicons } from '@expo/vector-icons'

// styles
import {
  globalStyles,
  colorPalette,
  fontPalette
} from '../static/styles/global'

// screens & components
import HomeStack from './HomeStack'

// stores
import { usePersonalStore } from '../stores/personalInfo'
import { useHomeStore } from '../stores/home'
import { useTranslation } from 'react-i18next'
import WelcomeSlider from '../screens/home/welcome/WelcomeSlider'
import AsyncStorage from '@react-native-async-storage/async-storage'

const Tab = createBottomTabNavigator()

const TabNavigator = ({ route }): JSX.Element => {
  // params
  const { params } = route
  const { mostRecentUserOnBoardings: userId, userkey } = params

  // stores' data
  const personalStore = usePersonalStore()
  const homeStore = useHomeStore()
  const { t } = useTranslation()

  const tabOptions = ({ navigation }) => ({
    headerShown: homeStore?.homeData?.isMaintanance ? false : true,
    title: '',
    headerStyle: {
      backgroundColor: colorPalette.primary
    },
    headerShadowVisible: false,
    headerTitleStyle: {
      fontFamily: fontPalette.primaryRegular,
      color: colorPalette.white
    },
    headerTintColor: colorPalette.white,
    headerLeft: () => {
      return (
        <TouchableOpacity
          onPress={() => {
            if (homeStore?.toggleProfile) {
              navigation.navigate('Profile')
            } else {
              navigation.goBack()
            }
            homeStore?.setToggleProfile(!homeStore?.toggleProfile)
          }}
          style={[styles.headerLeft]}
        >
          <View style={[styles.headerLeftIcon]}>
            <Ionicons name="person-circle-outline" size={24} color="white" />
          </View>
          <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
            {t('Welcomeuser')} {personalStore?.personalData?.firstName}
          </Text>
          <View
            style={[
              styles.headerArrowIcon,
              !homeStore?.toggleProfile && styles.headerArrowIconOpen
            ]}
          >
            <Octicons
              name={homeStore?.toggleProfile ? 'chevron-down' : 'chevron-up'}
              size={20}
              color="white"
            />
          </View>
        </TouchableOpacity>
      )
    },
    headerRight: () => (
      <View style={[styles.headerRight]}>
        <Image
          source={{
            uri: homeStore?.homeData?.brandingLogo
          }}
          style={[globalStyles.brand]}
        />
      </View>
    )
  })

  const fetchDataAsync = async () => {
    await personalStore.fetchData(userId)
    await homeStore.fetchData(userId)
    await homeStore.fetchCompanyName(userkey)
  }

  useEffect(() => {
    fetchDataAsync()
  }, [])

  return (
    <>

      {homeStore.homeData?.firstDay == 0 && homeStore.homeData?.isOnboarded ? (
        // {homeStore.homeData?.firstDay == 0 || homeStore.homeData?.firstDay == null && !homeStore.homeData?.isOnboarded ? (


        < Tab.Navigator
          screenOptions={({ route }) => ({
            tabBarIcon: ({ focused, color, size }) => {
              let iconName: any
              iconName = focused ? 'home-outline' : 'home-outline'

              return <Ionicons name={iconName} size={24} color={color} />
            },
            tabBarShowLabel: false,
            tabBarActiveTintColor: 'rgba(255, 255, 255, 1)',
            tabBarInactiveTintColor: 'rgba(255, 255, 255, .25)',
            tabBarActiveBackgroundColor: 'transparent',
            tabBarInactiveBackgroundColor: colorPalette.primary,
            tabBarStyle: {
              backgroundColor: colorPalette.primary,
              borderTopWidth: 1,
              borderTopColor: colorPalette.primary,
              elevation: 0,
              display: 'none'
            },
            headerStyle: {
              backgroundColor: colorPalette.primary,
              borderBottomColor: colorPalette.primary,
              borderBottomWidth: 0,
              elevation: 0,
              shadowOpacity: 0,
            },
            headerTitleStyle: {
              fontFamily: fontPalette.primaryBold,
              color: 'rgba(15, 23, 42, 1)'
            },
            headerShown: false
          })}
        >
          <Tab.Screen
            options={tabOptions}
            name="WelcomeSlider"
            component={WelcomeSlider}
            initialParams={{ ...params }}
          />
          <Tab.Screen
            options={tabOptions}
            name="HomeStack"
            component={HomeStack}
            initialParams={{ ...params }}
          />
        </Tab.Navigator >
      ) : (
        <>
          <Tab.Navigator
            screenOptions={({ route }) => ({
              tabBarIcon: ({ focused, color, size }) => {
                let iconName: any
                iconName = focused ? 'home-outline' : 'home-outline'

                return <Ionicons name={iconName} size={24} color={color} />
              },
              tabBarShowLabel: false,
              tabBarActiveTintColor: 'rgba(255, 255, 255, 1)',
              tabBarInactiveTintColor: 'rgba(255, 255, 255, .25)',
              tabBarActiveBackgroundColor: 'transparent',
              tabBarInactiveBackgroundColor: colorPalette.primary,
              tabBarStyle: {
                backgroundColor: colorPalette.primary,
                borderTopWidth: 1,
                borderTopColor: colorPalette.primary,
                elevation: 0,
                display: 'none'
              },
              headerStyle: {
                backgroundColor: colorPalette.primary,
                borderBottomColor: colorPalette.primary,
                borderBottomWidth: 0,
                elevation: 0,
                shadowOpacity: 0
              },
              headerTitleStyle: {
                fontFamily: fontPalette.primaryBold,
                color: 'rgba(15, 23, 42, 1)'
              },
              headerShown: false
            })}
          >
            <Tab.Screen
              options={tabOptions}
              name="HomeStack"
              component={HomeStack}
              initialParams={{ ...params }}
            />
          </Tab.Navigator>
        </>
      )
      }
    </>
  )
}

const styles = StyleSheet.create({
  headerLeft: {
    flexDirection: 'row',
    paddingLeft: 16
  },
  headerLeftIcon: {
    marginRight: 7,
    position: 'relative',
    top: -3
  },
  headerArrowIcon: {
    marginLeft: 10,
    position: 'relative',
    top: -2
  },
  headerArrowIconOpen: {
    top: 0
  },
  headerRight: {
    paddingRight: 16
  }
})

export default TabNavigator
